import { InvalidContactMessageError } from '../errors/InvalidContactMessageError';

// Accepts Iranian mobile numbers in local (09xxxxxxxxx) or international
// (+989xxxxxxxxx) format, since the company's offices are in Iran.
const IRAN_PHONE_PATTERN = /^(?:\+98|0)9\d{9}$/;

/**
 * Value Object for an optional contact phone number. `create` is only called
 * when a phone value was actually provided — the field itself is optional
 * at the entity level (see ContactMessage.entity.ts).
 */
export class PhoneNumber {
  public readonly value: string;

  private constructor(value: string) {
    this.value = value;
    Object.freeze(this);
  }

  public static create(rawValue: string): PhoneNumber {
    const value = rawValue.trim().replace(/[\s-]/g, '');
    if (!IRAN_PHONE_PATTERN.test(value)) {
      throw new InvalidContactMessageError(
        `"${rawValue}" is not a valid phone number (expected format: 09xxxxxxxxx or +989xxxxxxxxx).`
      );
    }
    return new PhoneNumber(value);
  }
}
